import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Gizlilik Politikası</h1>
          <p className="text-xl text-teal-50">Son Güncelleme: 10 Nisan 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Giriş</h2>
                <p className="text-gray-600 leading-relaxed">
                  CLND Menkul Değerler A.Ş. olarak, kişisel verilerinizin güvenliği bizim için son derece önemlidir. 
                  Bu Gizlilik Politikası, kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve 
                  korunduğunu açıklamaktadır.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Toplanan Bilgiler</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Hizmetlerimizi sunabilmek için aşağıdaki bilgileri toplayabiliriz:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Ad, soyad ve iletişim bilgileri</li>
                  <li>TC Kimlik numarası ve kimlik bilgileri</li>
                  <li>Finansal bilgiler ve işlem geçmişi</li>
                  <li>Hesap bilgileri ve yatırım tercihleri</li>
                  <li>İnternet sitesi kullanım bilgileri</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Bilgilerin Kullanımı</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Topladığımız kişisel veriler aşağıdaki amaçlarla kullanılmaktadır:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Hesap açma ve kimlik doğrulama işlemleri</li>
                  <li>Yatırım işlemlerinin gerçekleştirilmesi</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Müşteri destek hizmetlerinin sunulması</li>
                  <li>Hizmet kalitesinin iyileştirilmesi</li>
                  <li>İzniniz dahilinde pazarlama faaliyetleri</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Bilgi Güvenliği</h2>
                <p className="text-gray-600 leading-relaxed">
                  Kişisel verileriniz, yetkisiz erişim, kayıp veya kötüye kullanıma karşı en üst düzey güvenlik 
                  önlemleriyle korunmaktadır. SSL şifreleme, güvenlik duvarları ve erişim kontrolleri gibi 
                  teknik ve idari tedbirler uygulanmaktadır.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Bilgi Paylaşımı</h2>
                <p className="text-gray-600 leading-relaxed">
                  Kişisel verileriniz, yasal zorunluluklar, düzenleyici kurumların talepleri veya hizmetlerimizi 
                  sunmak için gerekli olan durumlarda üçüncü taraflarla paylaşılabilir. Bu paylaşımlar, 
                  gizlilik ve güvenlik standartlarına tam uyum sağlanarak gerçekleştirilir.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Haklarınız</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  KVKK kapsamında aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                  <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
                  <li>Kişisel verilerin düzeltilmesini isteme</li>
                  <li>Kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Çerezler</h2>
                <p className="text-gray-600 leading-relaxed">
                  Web sitemizde kullanıcı deneyimini geliştirmek için çerezler kullanılmaktadır. 
                  Çerez kullanımı hakkında detaylı bilgi için Çerez Politikamızı inceleyebilirsiniz.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. İletişim</h2>
                <p className="text-gray-600 leading-relaxed">
                  Gizlilik politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <p className="text-gray-600 mt-3">
                  <strong>E-posta:</strong> destek@clndonlinesube.com
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg mt-8">
                <p className="text-sm text-gray-600">
                  Bu Gizlilik Politikası, yasal düzenlemelerdeki değişiklikler veya hizmetlerimizdeki 
                  güncellemeler doğrultusunda revize edilebilir. Önemli değişiklikler olması durumunda 
                  tarafınıza bildirimde bulunulacaktır.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
